


const enablelogger = true;

const logger = (text, value) => {
    if (enablelogger)
        console.log(text, value);
}

export default logger;